var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", { staticClass: "grand-size-text leads" }, [_vm._v("Leads")]),
    _c("div", { staticClass: "card-item" }, [
      _c("div", { staticClass: "columns mx-auto is-multiline header-btn" }, [
        _c("div", { staticClass: "column is-10-until-widescreen" }, [
          _c("div", { staticClass: "columns is-multiline header-btn" }, [
            _c(
              "div",
              { staticClass: "column is-10-until-widescreen" },
              [
                _c("FindLeadsInput", {
                  staticClass: "search-leads",
                  attrs: { placeholder: "Buscar leads", expanded: true },
                  on: {
                    select: function ($event) {
                      return _vm.goToSingleProspectView($event._id)
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-10-until-widescreen" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      id: "download-csv-leads",
                      loading: _vm.CSVisLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.getCSVProspects()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("descargarCSV")))]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            [
              _c("LeadsFilters", {
                on: {
                  input: function ($event) {
                    return _vm.loadProspects("newFilterSelected")
                  },
                },
                model: {
                  value: _vm.filters,
                  callback: function ($$v) {
                    _vm.filters = $$v
                  },
                  expression: "filters",
                },
              }),
              _c("h5", { staticClass: "has-text-centered" }, [
                _vm._v(" " + _vm._s(_vm.$t("filterResult")) + " "),
                _c("span", { staticClass: "has-text-wight-bold" }, [
                  _vm._v(
                    _vm._s(_vm.pagination.numberOfDocuments) +
                      " lead" +
                      _vm._s(_vm.prospects.length > 1 ? "s" : "") +
                      "."
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "container" },
            [
              _vm.isLoading ? _c("Spinner") : _vm._e(),
              _vm.prospects.length === 0 && !_vm.isLoading
                ? _c("Message", {
                    attrs: {
                      message: _vm.mainMessage.message,
                      icon: _vm.mainMessage.icon,
                      "as-card": false,
                    },
                  })
                : _vm._e(),
              !_vm.isLoading
                ? _c(
                    "div",
                    {
                      staticClass: "default-item",
                      attrs: { "data-cy": "lead-container" },
                    },
                    _vm._l(_vm.prospects, function (prospect) {
                      return _c(
                        "div",
                        {
                          key: prospect._id,
                          staticClass:
                            "card-item shadowless has-text-centered default-item-info med-size-text my-3",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "default-item-prospect-broker" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "default-item-name content-title",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(prospect.name) +
                                      " " +
                                      _vm._s(prospect.lastName) +
                                      " "
                                  ),
                                ]
                              ),
                              prospect.hasOffer === false
                                ? _c(
                                    "span",
                                    { staticClass: "no-offer-tag creditu-tag" },
                                    [_vm._v(_vm._s(_vm.$t("no-offer")))]
                                  )
                                : _vm._e(),
                              prospect.brokerId
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "prospect-broker-tag creditu-tag is-hidden-tablet is-hidden-desktop",
                                    },
                                    [_vm._v("Broker")]
                                  )
                                : _vm._e(),
                              prospect.brokerSource
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "prospect-broker-tag creditu-tag is-hidden-tablet is-hidden-desktop",
                                    },
                                    [_vm._v(_vm._s(prospect.brokerSource.name))]
                                  )
                                : _vm._e(),
                              prospect.brokerId
                                ? _c(
                                    "b-tooltip",
                                    {
                                      staticClass:
                                        "prospect-broker-tag-tooltip creditu-tag is-hidden-mobile",
                                      attrs: {
                                        label: _vm.$t("brokerProspect"),
                                        position: "is-right",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "prospect-broker-tag creditu-tag",
                                        },
                                        [_vm._v("Broker")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              prospect.brokerSource
                                ? _c(
                                    "b-tooltip",
                                    {
                                      staticClass:
                                        "prospect-broker-tag-tooltip creditu-tag is-hidden-mobile",
                                      attrs: {
                                        label: _vm.$t("brokerSource"),
                                        position: "is-right",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "broker-source-tag creditu-tag",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(prospect.brokerSource.name)
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("span", { staticClass: "default-item-idnumber" }, [
                            _vm._v(" " + _vm._s(prospect.idNumber) + " "),
                          ]),
                          prospect.lastInteractionDate
                            ? _c("span", { staticClass: "default-item-date" }, [
                                _c("i", {
                                  staticClass:
                                    "fas fa-history has-text-primary",
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatDate(
                                        prospect.lastInteractionDate,
                                        "DD/MM/YY HH:mm"
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _c("span", { staticClass: "default-item-date" }, [
                                _c("i", {
                                  staticClass:
                                    "fas fa-history has-text-primary",
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatDate(
                                        prospect.createdAt,
                                        "DD/MM/YY HH:mm"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                          _c("span", { staticClass: "default-item-stage" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(`prospectStatus.${prospect.status}`)
                                )
                            ),
                            _c("br"),
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  `prospectSubStatus.${prospect.subStatus}`
                                )
                              ) + " "
                            ),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass:
                                "button manage-button is-button-secondary is-rounded is-fullwidth-mobile",
                              attrs: { id: `prospect-${prospect._id}` },
                              on: {
                                click: function ($event) {
                                  return _vm.goToSingleProspectView(
                                    prospect._id
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("button-manage")) + " "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              !_vm.isLoading && _vm.prospects.length > 0
                ? _c("CredituPagination", {
                    attrs: {
                      "documents-per-page": _vm.pagination.documentsPerPage,
                      total: _vm.pagination.numberOfDocuments,
                      "page-number": _vm.pagination.pageNumber,
                      size: "is-small",
                      "items-name": "Leads",
                      "range-before": 1,
                      "range-after": 1,
                      "documents-per-page-options": [5, 10, 20, 50],
                    },
                    on: {
                      "update:documentsPerPage": [
                        function ($event) {
                          return _vm.$set(
                            _vm.pagination,
                            "documentsPerPage",
                            $event
                          )
                        },
                        function ($event) {
                          return _vm.catchUpdatePagination(
                            "setPaginationDocumentsPerPage",
                            $event
                          )
                        },
                      ],
                      "update:documents-per-page": function ($event) {
                        return _vm.$set(
                          _vm.pagination,
                          "documentsPerPage",
                          $event
                        )
                      },
                      "update:pageNumber": [
                        function ($event) {
                          return _vm.$set(_vm.pagination, "pageNumber", $event)
                        },
                        function ($event) {
                          return _vm.catchUpdatePagination(
                            "setPaginationPageNumber",
                            $event
                          )
                        },
                      ],
                      "update:page-number": function ($event) {
                        return _vm.$set(_vm.pagination, "pageNumber", $event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }